export default __webpack_public_path__ + "static/media/hombre-revisando-documento.15ea300e.jpg";